import { Suspense } from 'react'
import { Routes, Route } from 'react-router-dom'
import { useAuth } from '../hooks/auth/auth.hook'
import { BookingEngineLayout } from '../layouts/booking-engine/booking-engine.layout'
import { GuestPortalLayout } from '../layouts/guest-portal/guest-portal.layout'
import { QuotationLayout } from '../layouts/quotation/quotation.layout'
import MissingAuthPage from '../pages/missing-auth'
import TemporaryHomePage from '../pages/temporary-home'
import { bookingEngineRoutes, guestPortalRoutes, quotationRoutes } from './routes'
import HiCLoading from '../components/HiCLoading'
import { ReservationIdProvider } from '../hooks/context/reservationId/reservation-id.context'

export const RouterConfig = () => {
  return (
    <Routes>
      {/* TEMPORARY */}
      <Route path="/" element={<TemporaryHomePage />} />
      {bookingEngineRoutes.map(({ path, Component }) => (
        <Route
          path={path}
          key={path}
          element={
            <BookingEngineLayout>
              <Suspense fallback={<HiCLoading />}>
                <Component />
              </Suspense>
            </BookingEngineLayout>
          }
        />
      ))}
      {guestPortalRoutes.map(({ path, Component }) => (
        <Route
          path={path}
          key={path}
          element={
            <RequireAuth>
              <ReservationIdProvider>
                <GuestPortalLayout>
                  <Suspense fallback={<HiCLoading />}>
                    <Component />
                  </Suspense>
                </GuestPortalLayout>
              </ReservationIdProvider>
            </RequireAuth>
          }
        />
      ))}
      {quotationRoutes.map(({ path, Component }) => (
        <Route
          path={path}
          key={path}
          element={
            <RequireAuth>
              <QuotationLayout>
                <Suspense fallback={<HiCLoading />}>
                  <Component />
                </Suspense>
              </QuotationLayout>
            </RequireAuth>
          }
        />
      ))}
    </Routes>
  )
}

const RequireAuth = (props: { children: JSX.Element }) => {
  const { auth } = useAuth()
  if (auth.loading) {
    return <HiCLoading />
  } else if (!auth.isAuthenticated) {
    return <MissingAuthPage />
  } else {
    return props.children
  }
}
